import axios from "../plugins/axios.js";

class ItensMenuService {
  async getItensMenuAll() {
    try {
      let response = await axios
        .get("/getItensMenuAll")
        .then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error);
    }
  }

  async getItensDescricaoFiltro() {
    try {
      let response = await axios
        .get("/ItensMenuDescricaoFiltro")
        .then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error);
    }
  }

  async getItensMenuAllConf() {
    try {
      let response = await axios
        .get("/getItensMenuAllConf")
        .then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error);
    }
  }

  async getAcessoMenuInstituicao(fkMenu) {
    try {
      let response = await axios
        .get(`/getAcessoMenuInstituicao/${fkMenu}`)
        .then((res) => res.data);
      if (response) return response;
    } catch (error) {
      console.log(error);
    }
  }

  async updateItemMenu(item) {
    try {
      let response = await axios
        .post("/updateItemMenu", item)
        .then((res) => res.data);
      if (response.affectedRows >= 1) {
        return 200;
      } else {
        return 500;
      }
    } catch (error) {}
  }
}
export default new ItensMenuService();
